/**
 * @fileoverview Experiment goal metrics — events counted as conversions in analysis.
 */

import type { ExperimentMetric } from "./types"

/** Metrics eligible for experiment conversion ledger writes. */
export const CONVERSION_METRICS: ReadonlySet<string> = new Set<ExperimentMetric>([
  "sign_up_click",
  "request_access_start",
  "request_access_submit",
  "begin_checkout",
  "purchase",
  "email_capture",
  "page_view",
  "scroll_depth",
  "footer_link_click",
])
